import { render, staticRenderFns } from "./GymAlerts.vue?vue&type=template&id=56670ba6&scoped=true"
import script from "./GymAlerts.vue?vue&type=script&lang=js"
export * from "./GymAlerts.vue?vue&type=script&lang=js"
import style0 from "./GymAlerts.vue?vue&type=style&index=0&id=56670ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56670ba6",
  null
  
)

export default component.exports